var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute top-0 flex justify-evenly w-full bg-gray-900 text-white"},[_c('button',{on:{"click":_vm.email}},[_vm._v("EMAIL (måste klicka innan AUTH)")]),_c('button',{on:{"click":_vm.auth}},[_vm._v("AUTH")]),_c('button',{on:{"click":_vm.claim}},[_vm._v("CLAIM")]),_c('button',{on:{"click":_vm.cheat}},[_vm._v("FUSKA")])])
}
var staticRenderFns = []

export { render, staticRenderFns }